import React from "react";
import { Chip } from "@mui/material";
import { motion } from "framer-motion";

// Tipi per il componente
interface LoadingChipProps {
    label: string;
    color?: string;
    pulse?: boolean;
}

/**
 * Chip MUI con animazione pulsante usando Framer Motion.
 * Ottimo per indicare uno stato di elaborazione o caricamento.
 */
export const LoadingChip: React.FC<LoadingChipProps> = ({
                                                                  label,
                                                                  color = "warning",
                                                                  pulse = true,
                                                              }) => {
    return (
        <motion.div
            animate={
                pulse
                    ? { opacity: [0.6, 1, 0.6], scale: [1, 1.05, 1] }
                    : { opacity: 1, scale: 1 }
            }
            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
            style={{ display: "inline-block" }}
        >
            <Chip label={label} sx={{backgroundColor: color}} size="small" />
        </motion.div>
    );
};

export default LoadingChip
